import React from "react";
import { Center, Loader, Text, Group, Table } from "@mantine/core";
import { useQuery } from "@apollo/client";
import dayjs from "dayjs";

import { GET_SUBSCRIBERS } from "../../gqls/subscriber";

export const SubscribersPage = () => {
  const { data, loading } = useQuery(GET_SUBSCRIBERS, {
    fetchPolicy: "network-only",
  });

  const subscribers = data?.subscribers || [];

  return (
    <>
      <Group align="center" justify="space-between">
        <Text fw="600">Подписчики (Реестр Email)</Text>
      </Group>

      {loading ? (
        <Center h={200}>
          <Loader size="sm" />
        </Center>
      ) : (
        <Table mt={16} highlightOnHover withBorder withColumnBorders>
          <thead>
            <tr>
              <th style={{ width: "60px", textAlign: "left" }}>№</th>
              <th style={{ textAlign: "left" }}>Email</th>
              <th style={{ width: "200px", textAlign: "left" }}>
                Дата подписки
              </th>
            </tr>
          </thead>
          <tbody>
            {subscribers.length === 0 ? (
              <tr>
                <td colSpan={3}>
                  <Text ta="center" c="gray" size="sm" my={10}>
                    Список подписчиков пуст
                  </Text>
                </td>
              </tr>
            ) : (
              subscribers.map((item, index) => (
                <tr key={item.id}>
                  <td style={{ textAlign: "left" }}>{index + 1}</td>
                  <td>
                    <Text fw={500} ta="left">
                      {item.email}
                    </Text>
                  </td>
                  <td>
                    <Text c="gray" size="sm" ta="left">
                      {dayjs(item.createdAt).format("DD.MM.YYYY HH:mm")}
                    </Text>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      )}
    </>
  );
};
